export const ADD_PATTERN = 'ADD_PATTERN';
export const EDIT_PATTERN = 'EDIT_PATTERN';
export const VOTE_PATTERN = 'VOTE_PATTERN';
export const CLOSE_PATTERN_DETAILS = 'CLOSE_PATTERN_DETAILS';
export const LIST_RELOADED = 'LIST_RELOADED';
export const EXECUTIONS_LIST_RELOADED = 'EXECUTIONS_LIST_RELOADED';
export const NEW_PATTERN_CLOSED = 'NEW_PATTERN_CLOSED';
export const NEW_PATTERN_OPEN = 'NEW_PATTERN_OPEN';
export const SELECT_PATTERN = 'SELECT_PATTERN';

export const ADD_GAME = 'ADD_GAME';
export const EDIT_GAME = 'EDIT_GAME';
export const CLOSE_GAME_DETAILS = 'CLOSE_GAME_DETAILS';
export const NEW_GAME_CLOSED = 'NEW_GAME_CLOSED';
export const NEW_GAME_OPEN = 'NEW_GAME_OPEN';
export const SELECT_GAME = 'SELECT_GAME';


export const ADD_EXERCISE = 'ADD_EXERCISE';
export const EDIT_EXERCISE = 'EDIT_EXERCISE';
export const CLOSE_EXERCISE_DETAILS = 'CLOSE_EXERCISE_DETAILS';
export const NEW_EXERCISE_CLOSED = 'NEW_EXERCISE_CLOSED';
export const NEW_EXERCISE_OPEN = 'NEW_EXERCISE_OPEN';
export const SELECT_EXERCISE = 'SELECT_EXERCISE';

export const ADD_EXECUTION = 'ADD_EXECUTION';
export const EDIT_EXECUTION = 'EDIT_EXECUTION';
export const CLOSE_EXECUTION_DETAILS = 'CLOSE_EXECUTION_DETAILS';
export const NEW_EXECUTION_CLOSED = 'NEW_EXECUTION_CLOSED';
export const NEW_EXECUTION_OPEN = 'NEW_EXECUTION_OPEN';
export const SELECT_EXECUTION = 'SELECT_EXECUTION';




export const UPDATE_KEYWORDS_FILTER = 'UPDATE_KEYWORDS_FILTER';
export const UPDATE_CONDITIONS_FILTER = 'UPDATE_CONDITIONS_FILTER';
export const UPDATE_CONSTRAINTS_FILTER = 'UPDATE_CONSTRAINTS_FILTER';
export const UPDATE_CONSEQUENCES_FILTER = 'UPDATE_CONSEQUENCES_FILTER';
export const UPDATE_AUTHORS_FILTER = 'UPDATE_AUTHORS_FILTER';
export const UPDATE_GROUPS_FILTER = 'UPDATE_GROUPS_FILTER';
export const UPDATE_PATTERN_NAME_FILTER = 'UPDATE_PATTERN_NAME_FILTER';
export const UPDATE_EXAMPLE_GAMES_FILTER = 'UPDATE_EXAMPLE_GAMES_FILTER';
export const UPDATE_DESCRIPTION_FILTER = 'UPDATE_DESCRIPTION_FILTER';
export const UPDATE_DESIGN_PROBLEM_FILTER = 'UPDATE_DESIGN_PROBLEM_FILTER';
export const CLEAR_PATTERN_FILTERS = 'CLEAR_PATTERN_FILTERS';

export const UPDATE_PAGINATION = 'UPDATE_PAGINATION';
export const UPDATE_ORDER_BY = 'UPDATE_ORDER_BY';
export const SEARCH_TOGGLE = 'SEARCH_TOGGLE';

export const UPDATE_GAME_NAME_FILTER = 'UPDATE_GAME_NAME_FILTER';
export const UPDATE_GAME_DESCRIPTION_FILTER = 'UPDATE_GAME_DESCRIPTION_FILTER';
export const UPDATE_GAME_TYPES_FILTER = 'UPDATE_GAME_TYPES_FILTER';
export const UPDATE_GAME_PUBLISHERS_FILTER = 'UPDATE_GAME_PUBLISHERS_FILTER';
export const UPDATE_GAME_DEVELOPERS_FILTER = 'UPDATE_GAME_DEVELOPERS_FILTER';
export const UPDATE_RELEASE_START_FILTER = 'UPDATE_RELEASE_START_FILTER';
export const UPDATE_RELEASE_END_FILTER = 'UPDATE_RELEASE_END_FILTER';
export const UPDATE_GAMES_KEYWORDS_FILTER = 'UPDATE_GAMES_KEYWORDS_FILTER';
export const UPDATE_GAMES_AUTHOR_FILTER = 'UPDATE_GAMES_AUTHOR_FILTER'
export const UPDATE_GAMES_GAMES_STYLE_FILTER = 'UPDATE_GAMES_GAMES_STYLE_FILTER';
export const UPDATE_GAMES_PAGINATION = 'UPDATE_GAMES_PAGINATION';
export const UPDATE_GAMES_ORDER_BY = 'UPDATE_GAMES_ORDER_BY';
export const CLEAR_GAME_FILTERS = 'CLEAR_GAME_FILTERS'
export const SEARCH_GAMES_TOGGLE = 'SEARCH_GAMES_TOGGLE';




export const UPDATE_EXERCISE_NAME_FILTER = 'UPDATE_EXERCISE_NAME_FILTER';
export const UPDATE_EXERCISE_DESCRIPTION_FILTER = 'UPDATE_EXERCISE_DESCRIPTION_FILTER';
export const UPDATE_EXERCISES_AUTHOR_FILTER = 'UPDATE_EXERCISES_AUTHOR_FILTER'
export const UPDATE_EXERCISES_PAGINATION = 'UPDATE_EXERCISES_PAGINATION';
export const UPDATE_EXERCISES_ORDER_BY = 'UPDATE_EXERCISES_ORDER_BY';
export const CLEAR_EXERCISE_FILTERS = 'CLEAR_EXERCISE_FILTERS'
export const SEARCH_EXERCISES_TOGGLE = 'SEARCH_EXERCISES_TOGGLE';



export const UPDATE_EXECUTION_NAME_FILTER = 'UPDATE_EXECUTION_NAME_FILTER';
export const UPDATE_EXECUTION_DESCRIPTION_FILTER = 'UPDATE_EXECUTION_DESCRIPTION_FILTER';
export const UPDATE_EXECUTIONS_AUTHOR_FILTER = 'UPDATE_EXECUTIONS_AUTHOR_FILTER'
export const UPDATE_EXECUTIONS_PAGINATION = 'UPDATE_EXECUTIONS_PAGINATION';
export const UPDATE_EXECUTIONS_ORDER_BY = 'UPDATE_EXECUTIONS_ORDER_BY';
export const CLEAR_EXECUTION_FILTERS = 'CLEAR_EXECUTION_FILTERS'
export const SEARCH_EXECUTIONS_TOGGLE = 'SEARCH_EXECUTIONS_TOGGLE';


export const EDIT_USER_TOGGLE = 'EDIT_USER_TOGGLE';
export const EDIT_USER_SUBMIT = 'EDIT_USER_SUBMIT';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const PASSWORD_RESET_START = 'PASSWORD_RESET_START';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
//export const LOGGED_IN_STATE = 'LOGGED_IN_STATE';
export const BACK_TO_LOGIN = 'BACK_TO_LOGIN';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const UPDATE_AUTO_LOAD_GAME_EMBEDS = 'UPDATE_AUTO_LOAD_GAME_EMBEDS';
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';

// user modal related.
export const OPEN_USER_MODAL = 'OPEN_USER_MODAL';
export const CLOSE_USER_MODAL = 'CLOSE_USER_MODAL';
export const SELECT_USER = 'SELECT_USER';

export const OPEN_MISC_SEARCH_MODAL = 'OPEN_MISC_SEARCH_MODAL';
export const CLOSE_MISC_SEARCH_MODAL = 'CLOSE_MISC_SEARCH_MODAL';

export const OPEN_MERGE_SELECT_MODAL = 'OPEN_MERGE_SELECT_MODAL';
export const CLOSE_MERGE_SELECT_MODAL = 'CLOSE_MERGE_SELECT_MODAL';
export const SUBMIT_MERGE_SELECT_MODAL = 'SUBMIT_MERGE_SELECT_MODAL';
export const CLOSE_MERGE_MODAL = 'CLOSE_MERGE_MODAL';
export const SET_MERGE_MODAL_PROBLEMS = 'SET_MERGE_MODAL_PROBLEMS';


export const UPDATE_DRAGGING = 'UPDATE_DRAGGING'